import React, { memo } from 'react';
import { Header } from '../../components/layout/header';
import { ChangePasswordForm } from '../../components/uer/password';
import { MeApi } from '../../apis';
import { message } from 'antd';

const ChangePasswordScreen = memo(() => {
  const [messageApi, contextHolder] = message.useMessage();

  return (
    <>
      {contextHolder}
      <div className="flex-col bg-white rounded-[8px] p-5 h-[100vh]">
        <Header title="Нууц үг солих" isGoBack={false} />
        <ChangePasswordForm
          onSubmit={(values) => {
            try {
              MeApi.profilePassword({
                password: values.password,
                oldPassword: values.currentPassword,
              });
              messageApi.success('Нууц үг амжилттай шинэчлэгдлээ.');
            } catch (e) {
              console.log(e);
              messageApi.error('Шинэчлэх үед алдаа гарлаа.');
            }
          }}
        />
      </div>
    </>
  );
});

ChangePasswordScreen.displayName = 'ChangePasswordScreen';

export { ChangePasswordScreen };
